import { createRouter, createWebHistory } from 'vue-router';
import { useContextStore } from '@/stores/context';

const routes = [
    {
        path: "/",
        name: "public",
        component: () => import('@/layouts/DefaultLayout.vue'),
        redirect: "/",
        children: [
            {
                path: '',
                name: 'Home',
                component: () => import('@/views/HomePageView.vue')
            },
            {
                path: 'privacypolicy',
                name: 'PrivacyPolicy',
                component: () => import('@/views/PrivacyPolicyView.vue')
            },
            {
                path: 'thankYou',
                name: 'ThankYou',
                component: () => import('@/views/ThankYouView.vue')
            }
        ]
    },
    {
        path: "/",
        name: "special",
        component: () => import('@/layouts/SpecialLayout.vue'),
        redirect: "/",
        children: [
            {
                path: 'budget',
                name: 'Budget',
                component: () => import('@/views/BudgetView.vue')
            },
            {
                path: 'opportunity',
                name: 'Opportunity',
                component: () => import('@/views/MainCtaView.vue')
            },
            {
                path: '/my_library',
                name: 'my_library',
                component: () => import('@/views/LibraryView.vue')
            },
            {
                path: '/my_library/:project_folder/:project_file',
                name: 'LibraryCase',
                component: () => import('@/views/LibraryCaseView.vue')
            },{
                path: '/case/:project_folder/:project_file',
                name: 'LibraryCase',
                component: () => import('@/views/LibraryCaseView.vue')
            }
        ]
    },
    {
        path: '/loading',
        name: 'Loading',
        component: () => import('@/views/LoadingView.vue')
    },
    {
        path: '/action_not_allowed',
        name: 'ActionNotAllowed',
        component: () => import('@/views/NotAllowedActionView.vue')
    },
    {
        path: '/maintance',
        name: 'Maintance',
        component: () => import('@/views/MaintanceView.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/NotFoundView.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.path === from.path) {
            return false;
        }
        
        if (savedPosition) {
            return savedPosition;
        }
        
        return { top: 0 };
    }
});


/**
 * Middleware to check auth routes
 */
router.beforeEach((to, from, next) => {    
    if (['true', true].includes(process.env.VUE_APP_ON_MAINTANCE) && to.path != '/maintance') {
        return next('/maintance');
    }
    
    if (to.path !== from.path) {
        const context = useContextStore();
        context.setLoadingApplication(true);
    }
    
    next();
});

router.afterEach((to, from) => {
    if (to.path !== from.path) {
        const context = useContextStore();

        requestAnimationFrame(() => {
            context.setLoadingApplication(false);
        });
    }
});

export default router;
